(() => {
  if (window.QuadroProductVariants) { window.QuadroProductVariants.init(); return; }
  const bound = new WeakSet();
  const escapeHtml = (value) => String(value || "").replace(/[&<>"']/g, (character) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#039;"
  }[character]));

  const formatMeasurementHtml = (value) => escapeHtml(value)
    .replace(/m2/gi, "m<sup>2</sup>")
    .replace(/m²/gi, "m<sup>2</sup>");

  const escapeRegExp = (value) => String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const updateProductSourceIncludedSku = (variant, variants) => {
    const currentSku = String(variant.sku || "").trim();
    const knownSkus = Array.from(new Set(variants
      .map((item) => String(item.sku || "").trim())
      .filter(Boolean)))
      .sort((left, right) => right.length - left.length);

    document.querySelectorAll(".product-kits-source, .product-source").forEach((source) => {
      source.querySelectorAll(".quadro-kit-tabs").forEach((tabs) => {
        const tabItems = Array.from(tabs.children).filter((item) => item.classList.contains("quadro-kit-tab"));
        const includedTab = tabItems[1];
        const panelId = includedTab && includedTab.getAttribute("aria-controls");
        if (!panelId) return;

        const panel = Array.from(source.querySelectorAll(".quadro-kit-tab-content"))
          .find((item) => item.id === panelId);
        if (!panel) return;

        const existingMarker = panel.querySelector("[data-product-source-variant-sku]");
        if (existingMarker) {
          existingMarker.textContent = currentSku;
          const existingWrap = existingMarker.closest("[data-product-source-variant-sku-wrap]");
          if (existingWrap) existingWrap.hidden = !currentSku;
          return;
        }

        const listItems = Array.from(panel.querySelectorAll("li"));
        if (listItems.length === 0) return;

        let targetItem = null;
        let skuMatch = null;

        listItems.some((item) => {
          const text = item.textContent || "";
          return knownSkus.some((knownSku) => {
            const pattern = new RegExp(`[（(]\\s*${escapeRegExp(knownSku)}\\s*[)）]`);
            const match = text.match(pattern);
            if (!match) return false;
            targetItem = item;
            skuMatch = match;
            return true;
          });
        });

        if (!targetItem && source.classList.contains("product-kits-source")) {
          targetItem = listItems[0];
        }
        if (!targetItem) return;

        const originalText = (targetItem.textContent || "").trim();
        const baseText = skuMatch
          ? `${originalText.slice(0, skuMatch.index)}${originalText.slice(skuMatch.index + skuMatch[0].length)}`
            .replace(/\s{2,}/g, " ")
            .trim()
          : originalText;
        const useWideParentheses = skuMatch
          ? skuMatch[0].trim().startsWith("（")
          : String(document.documentElement.lang || "").toLowerCase().startsWith("zh");

        const skuWrap = document.createElement("span");
        skuWrap.dataset.productSourceVariantSkuWrap = "";
        skuWrap.hidden = !currentSku;
        skuWrap.append(document.createTextNode(useWideParentheses ? "（" : "("));

        const skuValue = document.createElement("span");
        skuValue.dataset.productSourceVariantSku = "";
        skuValue.textContent = currentSku;
        skuWrap.append(skuValue, document.createTextNode(useWideParentheses ? "）" : ")"));

        targetItem.textContent = baseText;
        targetItem.append(document.createTextNode(" "), skuWrap);
      });
    });
  };

  const setupProductVariants = (scope = document) => {
    const roots = [...(scope.matches?.("[data-product-root]") ? [scope] : []), ...scope.querySelectorAll("[data-product-root]")];
    roots.forEach((root) => {
      if (bound.has(root)) return;
      const select = root.querySelector("[data-variant-select]");
      const data = root.querySelector("[data-product-variants]");
      let image = root.querySelector("[data-product-image]");
      const lightboxTrigger = root.querySelector("[data-product-root-gallery-trigger]");
      const gallerySlides = Array.from(root.querySelectorAll("[data-product-gallery-slide]"));
      const galleryThumbs = Array.from(root.querySelectorAll("[data-product-gallery-thumb]"));
      const sku = root.querySelector("[data-variant-sku]");
      const skuRow = root.querySelector("[data-variant-sku-row]");
      const includedSku = root.querySelector("[data-variant-included-sku]");
      const includedSkuWrap = root.querySelector("[data-variant-included-sku-wrap]");
      const barcode = root.querySelector("[data-variant-barcode]");
      const barcodeRow = root.querySelector("[data-variant-barcode-row]");
      const variantTitle = root.querySelector("[data-variant-title]");
      const variantTitleRow = root.querySelector("[data-variant-title-row]");
      const dimension = root.querySelector("[data-variant-dimension]");
      const dimensionRow = root.querySelector("[data-variant-dimension-row]");
      const platform = root.querySelector("[data-variant-platform]");
      const platformRow = root.querySelector("[data-variant-platform-row]");
      const price = root.querySelector("[data-product-price]");
      const button = root.querySelector("[data-add-to-cart-button]");
      const swatches = Array.from(root.querySelectorAll("[data-variant-swatch]"));
      const links = Array.from(root.querySelectorAll("[data-product-link]"));

      if (!select || !data || !button) return;
      bound.add(root);

      let variants = [];
      try {
        variants = JSON.parse(data.textContent);
      } catch (error) {
        variants = [];
      }

      if (root.dataset.randomVariant === "true" && variants.length > 1) {
        const availableVariants = variants.filter((variant) => variant.available);
        const variantPool = availableVariants.length > 0 ? availableVariants : variants;
        const randomVariant = variantPool[Math.floor(Math.random() * variantPool.length)];
        if (randomVariant) select.value = String(randomVariant.id);
      }

      const setActiveGalleryImage = (imageId) => {
        if (!imageId || gallerySlides.length === 0) return false;
        const targetId = String(imageId);
        const activeSlide = gallerySlides.find((slide) => String(slide.dataset.productMediaImageId) === targetId);
        if (!activeSlide) return false;

        gallerySlides.forEach((slide) => {
          const isActive = slide === activeSlide;
          slide.classList.toggle("is-active", isActive);
          slide.hidden = !isActive;
        });

        galleryThumbs.forEach((thumb) => {
          const isActive = String(thumb.dataset.productMediaImageId) === targetId;
          thumb.classList.toggle("is-active", isActive);
          thumb.setAttribute("aria-current", isActive ? "true" : "false");
        });

        return true;
      };

      galleryThumbs.forEach((thumb) => {
        thumb.addEventListener("click", () => {
          setActiveGalleryImage(thumb.dataset.productMediaImageId);
        });
      });

      const nativeMain = root.hasAttribute("data-native-main-product");
      const updateVariant = (event) => {
        const variant = variants.find((item) => String(item.id) === String(select.value));
        if (!variant) return;

        const galleryUpdated = variant.imageId && setActiveGalleryImage(variant.imageId);
        if (!galleryUpdated && image && variant.image) {
          if (window.QuadroProductMedia) window.QuadroProductMedia.update(image, variant);
          else {
            if (image.getAttribute('src') !== variant.image) {
              image.removeAttribute('srcset');
              image.src = variant.image;
            }
            image.alt = variant.imageAlt || "";
          }
        }

        if (lightboxTrigger && variant.imageFull) {
          lightboxTrigger.dataset.lightboxImageId = String(variant.imageId || "");
          lightboxTrigger.dataset.lightboxSrc = variant.imageFull;
          lightboxTrigger.dataset.lightboxThumb = variant.imageThumb || variant.imageFull;
          lightboxTrigger.dataset.lightboxAlt = variant.imageAlt || "";
        }

        if (sku) {
          sku.textContent = variant.sku || sku.dataset.empty;
          if (skuRow) skuRow.hidden = !variant.sku;
        }

        if (includedSku) {
          includedSku.textContent = variant.sku || "";
          if (includedSkuWrap) includedSkuWrap.hidden = !variant.sku;
        }

        updateProductSourceIncludedSku(variant, variants);

        if (barcode) {
          barcode.textContent = variant.barcode || barcode.dataset.empty;
          if (barcodeRow) barcodeRow.hidden = !variant.barcode;
        }

        if (variantTitle) {
          const title = variant.title === "Default Title" ? "" : variant.title;
          variantTitle.textContent = title;
          if (variantTitleRow) variantTitleRow.hidden = !title;
        }

        if (dimension) {
          dimension.innerHTML = formatMeasurementHtml(variant.dimension || "");
          if (dimensionRow) dimensionRow.hidden = !variant.dimension;
        }

        if (platform) {
          platform.innerHTML = formatMeasurementHtml(variant.platform || "");
          if (platformRow) platformRow.hidden = !variant.platform;
        }

        if (price) {
          price.textContent = variant.price;
        }

        button.disabled = !variant.available;
        button.setAttribute("aria-disabled", variant.available ? "false" : "true");
        button.textContent = variant.available ? button.dataset.addText : button.dataset.soldOutText;

        if (nativeMain) {
          const prices = root.querySelector("[data-price]");
          if (prices) {
            prices.classList.toggle("price--sold-out", !variant.available);
            prices.classList.toggle("price--on-sale", Boolean(variant.onSale));
            prices.classList.toggle("price--unit-available", Boolean(variant.hasUnitPrice));
            root.querySelectorAll("[data-regular-price]").forEach((node) => { node.textContent = variant.onSale ? variant.comparePrice : variant.price; });
            root.querySelectorAll("[data-sale-price]").forEach((node) => { node.textContent = variant.price; });
            root.querySelectorAll("[data-unit-price]").forEach((node) => { node.textContent = variant.unitPrice || ""; });
            root.querySelectorAll("[data-unit-price-base-unit]").forEach((node) => { node.textContent = variant.unitBase || ""; });
          }
          const shipping = root.querySelector("[data-native-shipping]");
          const soldOut = root.querySelector("[data-native-sold-out]");
          const anyAvailable = variants.some((item) => item.available);
          if (shipping) shipping.hidden = anyAvailable && !variant.available;
          if (soldOut) soldOut.hidden = !anyAvailable || variant.available;
          const status = root.querySelector("[data-native-product-status]");
          if (status) status.textContent = variant.price + (variant.available ? "" : " – " + button.dataset.soldOutText);
          if (event && event.type === "change") {
            const url = new URL(window.location.href);
            url.searchParams.set("variant", variant.id);
            window.history.replaceState({}, "", url);
            root.dispatchEvent(new CustomEvent("variant:change", { bubbles: true, detail: { variant } }));
          }
        }

        links.forEach((link) => {
          try {
            const url = new URL(link.href, window.location.origin);
            url.searchParams.set("variant", variant.id);
            link.href = `${url.pathname}${url.search}${url.hash}`;
          } catch (error) {
            return;
          }
        });

        swatches.forEach((swatch) => {
          const isActive = String(swatch.dataset.variantId) === String(variant.id);
          swatch.classList.toggle("is-active", isActive);
          swatch.setAttribute("aria-pressed", isActive ? "true" : "false");
        });
      };

      select.addEventListener("change", updateVariant);
      swatches.forEach((swatch) => {
        swatch.addEventListener("click", () => {
          select.value = swatch.dataset.variantId;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
      updateVariant();
    });
  };

  window.QuadroProductVariants = { init: setupProductVariants };
  setupProductVariants();
  document.addEventListener("shopify:section:load", event => setupProductVariants(event.target));
})();
